import { Injectable } from '@angular/core';

import { UiConfigurationService } from '../ui-configuration/ui-configuration.service';

/**
 * Service to change the icon name based on configuration
 * There are icons with a name non related to the physical equivalent one, so
 * a table is set in the configuration to point the real one
 */
@Injectable({ providedIn: 'root' })
export class IconNameTranslationService {
    private iconTranslation: Map<string, string> | null = null;

    constructor(private uiConfigurationService: UiConfigurationService) {}

    /**
     * Load current icon translation table from ui-configuration
     */
    loadIconsTranslation(): void {
        this.iconTranslation = new Map<string, string>();
        const iconsConfig = this.uiConfigurationService.uiConfiguration.iconTranslation;
        if (!iconsConfig) {
            return;
        }

        const iconsConfigKeys = Object.keys(iconsConfig);

        iconsConfigKeys.forEach((icon) => {
            this.iconTranslation?.set(icon, iconsConfig[icon]);
        });
    }

    /**
     * Returns the equivalent icon name, or the name passed if no translation is defined
     * @param iconName Icon name to translate
     */
    get(iconName: string): string {
        if (!this.iconTranslation) {
            this.loadIconsTranslation();
        }
        return this.iconTranslation?.get(iconName) ?? iconName;
    }
}
